import React, { Component } from 'react';
import loading from 'c-loading';
import url from 'c-url';

import lang from '../lang/index';
import Notification from './notification';
import '../../css/captcha-verify.less';
import CaptchaService from '../services/captcha-verify.service';

class CaptchaVerify extends Component {

    constructor(props) {
        super(props);

        this.state = {
            input: '',
            image: null,
            isWaiting: true
        };
    }

    componentWillMount() {
        this.fetchCaptchaInfo();
    }

    shouldComponentUpdate(prevProps, prevState) {
        return prevProps !== this.props || prevState !== this.state;
    }

    focusInput = (inputEl) => {
        this._inputEl = inputEl;
        if (inputEl) {
            inputEl.focus();
        }
    }

    fetchCaptchaInfo() {
        loading.show();

        const self = this;
        let fetchedResult;
        let data = {
            'verifyCode': url.query('code')
        };

        fetch = CaptchaService.fetchCaptchaInfo(data);

        fetch.then(fetchedResult => {
            loading.hide();
            let { reason, picData: image, result } = fetchedResult;

            // 根据后台返回开关字段，不需要验证的话，直接跳过图片验证相关
            if (reason == 2) {
                this.props.verifyPassed();
            } else if (reason == 3) {
                // 邮箱验证码错误
                this.props.verifyCodeFailed();
            } else {
                self.setState(prevState => {
                    return {
                        ...prevState,
                        image,
                        input: '',
                        isWaiting: false
                    };
                });
            }
        }, err => {
            loading.hide();

            new Notification({
                content: lang.template('网络连接有误, 请稍后再试')
            }).create();
        });
    }

    onInputChange() {
        this.setState(prevState => {
            return {
                ...prevState,
                inputCode: this._inputEl.value
            };
        });
    }

    submitToValidate(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        if (!this.state.inputCode || this.state.inputCode.trim().length == '') {
            this.setState(prevState => ({
                ...prevState,
                errorMsg: lang.template('请输入正确的验证码')
            }));
            return;
        }

        loading.show();

        let data = {
            verifyCode: url.query('code'),
            picCheckCode: this.state.inputCode
        };

        let fetch = CaptchaService.validateCaptcha(data);

        fetch.then(validateResult => {
            loading.hide();
            let { reason, result } = validateResult;
            console.log(validateResult);
            console.log('--------------');
            // 验证成功或验证关闭时直接跳转
            if (result == 1) {
                this.props.verifyPassed();
            } else {
                let errorMsg = '';
                if (reason == 2) {
                    this.props.verifyPassed();
                } else if (reason == 3) {
                    // errorMsg = '邮箱注册验证码不正确';
                    this.props.verifyCodeFailed();
                    return;
                } else if (reason == 4) {
                    // errorMsg = '图片验证码不正确';
                    errorMsg = lang.template('请输入正确的验证码');

                    this._inputEl.value = '';
                    setTimeout(() => {
                        this._inputEl.focus();
                    });
                    this.setState(prevState => ({ ...prevState, inputCode: '', errorMsg }));
                    this.fetchCaptchaInfo();
                    return;
                } else {
                    // errorMsg = '验证失败，请重试';
                    errorMsg = lang.template('请输入正确的验证码');
                }

                // 验证失败
                this.setState(prevState => {
                    return {
                        ...prevState,
                        errorMsg: errorMsg
                    };
                });
            }
        }, err => {
            loading.hide();

            new Notification({
                content: lang.template('网络连接有误, 请稍后再试')
            }).create();
        });
    }

    render() {
        if (this.state.isWaiting) {
            return (<div></div>);
        }
        const isHujing = url.query('feature') == 224;
        let appName = url.query('appname') || null;

        return (
            <div>
                {appName ? null :
                    <header className={isHujing ? 'hujing-logo' : 'logo'}></header>}
                <section className="captcha-form">
                    <div className="title">
                        <h2>{isHujing ? lang.template('Orcalive注册验证') : lang.template('Uplive注册验证')}</h2>
                        <p>{lang.template('此链接30分钟内有效，超时请返回应用重新发送')}</p>
                    </div>
                    <div>
                        <form onSubmit={e => this.submitToValidate(e)}>
                            <div>
                                <input onChange={this.onInputChange.bind(this)}
                                    ref={this.focusInput}
                                    type="text"
                                    autofocus="true"
                                    placeholder={lang.template('输入图片中的验证码')}></input>

                                <img src={'data:image/png;base64,' + this.state.image} />

                                <input type="button" onClick={this.fetchCaptchaInfo.bind(this)}
                                    className="btn-refresh" />
                            </div>
                            <div className="footer-button">
                                <input type="submit"
                                    className={isHujing ? "btn-submit-hj" : "btn-submit"}
                                    value={lang.template('确认验证')} />
                            </div>
                            <div className="error-tips">
                                <span>{this.state.errorMsg}</span>
                            </div>
                        </form>
                    </div>
                </section>
            </div>
        );
    }
}

export default CaptchaVerify;



// WEBPACK FOOTER //
// ./js/view/captcha-verify.js